import PropTypes from 'prop-types';
import { Btn } from './index';
import Icon from './Icon';
import { programSelectionReason } from '../utils/programPlanning';
import { formatDisplayDate } from '../utils/dateCalendar';
import './planning-workspace.css';
export default function OrderSelectionTable({
  items,
  selected,
  onToggle,
  onEdit,
  onDelete,
  busy,
  sourceLabel,
  highlighted = new Set()
}) {
  const selectedIds = new Set(selected.map(item => Number(item.id)));
  return <table className="rf-order-table"><thead><tr><th scope="col"><span className="sr-only">Selecionar pedido</span></th><th scope="col">Pedido</th><th scope="col">Horário / sentido</th><th scope="col">Empresa de destino</th><th scope="col">Passageiros</th><th scope="col">Seleção</th><th scope="col"><span className="sr-only">Ações</span></th></tr></thead><tbody>{items.map(item => {
        const checked = selectedIds.has(Number(item.id));
        const reason = programSelectionReason(item, selected);
        return <tr key={item.id} data-testid="order-row" data-highlighted={highlighted.has(Number(item.id)) || undefined} className={checked ? 'is-selected' : ''}>
      <td><label className="rf-order-check"><input type="checkbox" checked={checked} disabled={busy || !checked && Boolean(reason)} onChange={() => onToggle(item)} aria-label={`Selecionar pedido ${item.codigo}`} /></label></td>
      <td><strong>PG {item.codigo}</strong><p>{formatDisplayDate(item.data)} · {sourceLabel(item)}{highlighted.has(Number(item.id)) ? " · recém-importado" : ""}</p>{item.is_teste && <span className="planning-pill">Teste</span>}</td>
      <td data-label="Horário / sentido"><strong>{String(item.horario || '').slice(0, 5)}</strong><p>{item.trecho === 'ida' ? 'Ida' : 'Volta'}</p></td>
      <td data-label="Empresa de destino">{item.empresa_destino_nome || 'Destino não informado'}</td><td data-label="Passageiros">{Number(item.total_passageiros) || 0}<span className="rf-order-count-label"> {Number(item.total_passageiros) === 1 ? 'passageiro' : 'passageiros'}</span></td>
      <td data-label="Seleção"><span className={`planning-pill ${checked ? 'rf-order-selected' : ''}`}>{checked ? 'Selecionado' : reason || 'A planejar'}</span></td>
      <td><div className="rf-order-row-actions"><Btn size="sm" variant="secondary" aria-label={`Editar pedido ${item.codigo}`} disabled={busy} onClick={() => onEdit(item)}><Icon name="edit" size={15} /> Editar</Btn><Btn size="sm" variant="secondary" style={{ color: "var(--danger)" }} aria-label={`Excluir pedido ${item.codigo}`} disabled={busy} onClick={() => onDelete(item)}><Icon name="trash" size={16} /> Excluir</Btn></div></td>
    </tr>;
      })}</tbody></table>;
}
OrderSelectionTable.propTypes = {
  items: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  sourceLabel: PropTypes.func.isRequired,
  highlighted: PropTypes.instanceOf(Set),
  busy: PropTypes.bool
};
